<template>
  <div>
    <ButtonX />
    <b-container>
      <h1 id="montagsdemos">Montagsdemos</h1>
      <video src="../media/Montagsdemos.mp4" controls></video>
      <div class="bib">
        <h2 class="bib">Quellen</h2>
        <p class="bib">
          Bundeszentrale für politische Bildung (abgerufen am 30.09.2020)
          <i>Vor 30 Jahren: Die erste Montagsdemonstration</i>, Bundeszentrale für politische Bildung
          <a
            href="https://www.bpb.de/politik/hintergrund-aktuell/295940/montagsdemonstrationen"
          >https://www.bpb.de/politik/hintergrund-aktuell/295940/montagsdemonstrationen</a>
        </p>
        <p class="bib">
          Wikipedia (abgerufen am 30.09.2020)
          <i>Montagsdemonstrationen 1989/1990 in der DDR</i>, Wikipedia
          <a
            href="https://de.wikipedia.org/w/index.php?title=Montagsdemonstrationen_1989/1990_in_der_DDR&oldid=201599594"
          >https://de.wikipedia.org/w/index.php?title=Montagsdemonstrationen_1989/1990_in_der_DDR&oldid=201599594</a>
        </p>
        <p class="bib">Die Bildquellen sind an den jeweiligen Stellen im Video angegeben.</p>
      </div>
      <Footer />
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>